import React, { createContext, useContext, useEffect, useState } from 'react';
import { io } from 'socket.io-client';

const SocketContext = createContext(null);

export function SocketProvider({ children }) {
  const [socket, setSocket] = useState(null);
  const [waStatus, setWaStatus] = useState('disconnected');
  const [qrCode, setQrCode] = useState(null);
  const [pairingCode, setPairingCode] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('ax_token');
    if (!token) return;

    // Fetch current status immediately (do NOT auto-init — let user choose QR or pairing)
    fetch('/api/whatsapp/status', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => { if (data.status) setWaStatus(data.status); })
      .catch(() => {});

    // Connect via same origin so nginx proxies /socket.io/ to the backend
    const s = io('/admin', {
      auth: { token },
      transports: ['polling', 'websocket'],
    });

    s.on('connect', () => console.log('Socket connected'));
    s.on('connect_error', (err) => console.error('Socket error:', err.message));
    s.on('wa_status', ({ status, pairingCode: code }) => {
      setWaStatus(status);
      if (status === 'ready') { setQrCode(null); setPairingCode(null); }
      if (status === 'pairing_code' && code) setPairingCode(code);
    });
    s.on('wa_qr', ({ qr }) => { setQrCode(qr); setPairingCode(null); });

    setSocket(s);
    return () => s.disconnect();
  }, []);

  return (
    <SocketContext.Provider value={{ socket, waStatus, qrCode, pairingCode }}>
      {children}
    </SocketContext.Provider>
  );
}

export const useSocket = () => useContext(SocketContext);
